  $("#pre-confirmed").on("click", function(e){
     e.preventDefault();
    
    var quantity = $('#quantity').val();
    var variantId = document.querySelector('input[name="id"]').value;
    var drawer = document.querySelector('.js-ajax-cart');
    var backdrop = document.querySelector('.js-ajax-cart-backdrop');
    
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity='+quantity+'&id='+variantId,
      dataType: 'json',
      success: function(data){
        getCartData()
      },
      fail: function(e){
        console.log(e)
      }
    };
    
    $.ajax(params)
    
       function getCartData(){
              $.ajax({
                type: 'GET',
                url: '/cart.js',
                async: false,
                cache: false,
                dataType: 'json',
                success: function(data){
                  showDrawer()
                  updateDrawer(data)
                }
              })
            }
    
    function formatMoney(number, currency, locale){
              const stripZeros = false;
              var currency = 'USD';
              var locale = 'en-US';
              return stripZeros && number % 1 === 0 ? (number * 0.01).toLocaleString(locale, {style: 'currency', currency}).slice(0, -3) : (number * 0.01).toLocaleString(locale, {style: 'currency', currency})
    }
    
    function updateCartCount(data){
              const count = data.item_count;
 
              for(const counter of document.querySelectorAll('.js-ajax-cart-count')){
                counter.innerHTML = count;
              }
              for(const itemText of document.querySelectorAll('.js-ajax-cart-items-text')){
                if(count === 1){
                  itemText.innerHTML = 'Item'
                }else{
                  itemText.innerHTML = 'Items'
                }
              }
    }
    
            function updateCartSubtotal(data){
              const currency = data.currency;
              const subtotal = data.total_price;
 
              for(const price of document.querySelectorAll('.js-ajax-cart-subtotal')){
                price.innerHTML = formatMoney(subtotal, currency)
              }
            }
    
            function plus(){
                 return   `
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                   <title>plus</title>
                   <path d="M436 228H252V44c0-6.6-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12v184H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h184v184c0 6.6 5.4 12 12 12h32c6.6 0 12-5.4 12-12V284h184c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12z"/>
                   </svg>
                   `.trim()
             }
     
           function minus(){
                 return    `
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                   <title>minus</title>
                   <path d="M436 284c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h424z"/>
                   </svg>
                   `.trim()
             }
     
           function close(){
                 return  `
                   <svg class="svg-close" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                   <title>Close</title>
                   <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/>
                   </svg>
                   `.trim()
             }
           
           function cartItem(line, url, title, variant, quantity, image, price, sku, currency){
                 return    `
                   <div class="ajax-cart-item relative flex flex-wrap padding-vertical-5 padding-left-3 padding-right-5"
                     data-cart-line="${line}"
                     data-sku="${sku}">
 
                   <a href="${url}" class="block margin-right-3">
                     <img src="${image}" class="cart-item-image fit-cover block width-100" />
                   </a>
 
                   <div class="flex-item-1 margin-right-2">
                     <div class="height-100 flex flex-column justify-between">
 
                       <div>
                         <a href="${url}" class="ajax-cart-item-title block margin-vertical-0 link font-size-2">${title}</a>
                           ${
                             variant === null
                             ? ``
                             : `<p class="margin-vertical-0 font-size-1 text-grey">${variant}</p>`
                           }
                       </div>
 
                       <div class="js-number-input number-input margin-top-2">
                         <button type="button" data-behavior="decrement">${minus()}</button>
                         <input type="number" id="cart_quantity_${line}" name="cart_quantity_${line}" value="${quantity}" min="1" max="999" data-behavior="update-line" />
                         <button type="button" data-behavior="increment">${plus()}</button>
                       </div>
 
                     </div>
                   </div>
 
                   <div class="flex flex-column justify-between items-end">
                      <button class="ajax-cart-item-remove-button button-reset" data-behavior="remove-line">
                       ${close()}
                       </button>
 
                     <span class="font-size-2 font-weight-3">${formatMoney(
                       price,
                       currency
                     )}</span>
                   </div>
 
                   <div class="js-out-of-stock text-function-secondary text-right width-100
                       font-weight-5 font-size-2 padding-top-1"
                       style="display: none;" >
                       Out of stock
                   </div>
               </div>
               `.trim()  
               }
 
             function updateDrawer(data){
               const count = data.item_count;
               const currency = data.currency;
               const items = data.items;
               const cartEmpty = drawer.querySelector('.js-ajax-cart-empty');
               const cartFull = drawer.querySelector('.js-ajax-cart-full');
               const itemContainer = drawer.querySelector('.js-ajax-cart-items');
               const cartIcon = $('.js-cart-icon');
 
               updateCartCount(data);
               updateCartSubtotal(data)
 
               if(count === 0){
                 cartEmpty.classList.remove('hide');
                 cartFull.classList.add('hide');
                 itemContainer.innerHTML ="";
                 cartIcon.removeClass('cart-full')
                 return
               }else{
                 cartIcon.addClass('cart-full')
               }
 
               while(itemContainer.hasChildNodes()){
                 itemContainer.removeChild(itemContainer.firstChild)
               }
 
               cartEmpty.classList.add('hide');
               cartFull.classList.remove('hide');
 
               for(const [line, lineItem] of items.entries()){
                 var {url, product_title: title, variant_title: variant, quantity, image, discounted_price, sku} = lineItem;
                 image = image.replace('.jpg', '_150x.jpg');
                 var template =  document.createElement('template');
                 template.innerHTML = cartItem(line+1, url, title, variant, quantity, image, discounted_price, currency, sku)
 
                 itemContainer.appendChild(template.content.firstChild)
               }
             }
           
           function showDrawer(){
             if(!drawer.classList.contains('is-closed')){
               return
             }
             drawer.classList.remove('is-closed');
             backdrop.classList.remove('is-closed');
             document.body.classList.add('overflow-y-hidden');
           }
 
          function toggleDrawer(event){
            if(!event.target.closest('[data-behaviour="toggle-cart"]')){
              return
            }
            event.preventDefault()
 
            backdrop.classList.toggle('is-closed')
            drawer.classList.toggle('is-closed')
            document.body.classList.toggle('overflow-y-hidden')
          }
          
          if(drawer){
            document.addEventListener('click', toggleDrawer)
 
            const cartData = new Promise((resolve, reject) => {
              getCartData()
            })
 
            cartData.then(data => { updateDrawer(data)}).catch(error => console.error(error))
          }
      
  })